import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { inr } from "@/lib/format";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

export function KPI({ label, value, delta, suffix = "", icon: Icon, tone = "default", compact = false, testId }) {
  const toneMap = {
    default: "text-primary",
    good: "text-emerald-600",
    warn: "text-amber-600",
    bad: "text-destructive",
  };
  const isCurrency = typeof value === "number" && !suffix;
  const displayValue = isCurrency ? inr(value, { compact }) : (typeof value === "number" ? value.toLocaleString("en-IN") : value);

  return (
    <Card className="border shadow-none" data-testid={testId}>
      <CardContent className="p-4">
        <div className="flex items-start justify-between mb-2">
          <div className="text-[11px] uppercase tracking-wider text-muted-foreground font-mono">{label}</div>
          {Icon && <Icon className={cn("h-4 w-4", toneMap[tone])} />}
        </div>
        <div className={cn("kpi-num text-2xl md:text-3xl", toneMap[tone])}>
          {displayValue}{suffix}
        </div>
        {delta !== undefined && delta !== null && (
          <div className={cn("text-xs mt-1 flex items-center gap-1", delta >= 0 ? "text-emerald-600" : "text-destructive")}>
            {delta >= 0 ? <ArrowUpRight className="h-3 w-3" /> : <ArrowDownRight className="h-3 w-3" />}
            {Math.abs(delta).toFixed(1)}% vs last period
          </div>
        )}
      </CardContent>
    </Card>
  );
}

export function SectionHeader({ title, subtitle, right }) {
  return (
    <div className="flex items-end justify-between mb-4 mt-2">
      <div>
        <h2 className="font-display text-xl font-bold tracking-tight">{title}</h2>
        {subtitle && <p className="text-sm text-muted-foreground mt-0.5">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function EmptyRow({ colSpan = 6, text = "No records yet" }) {
  return (
    <tr>
      <td colSpan={colSpan} className="py-8 text-center text-sm text-muted-foreground">
        {text}
      </td>
    </tr>
  );
}
